<template>
  <component :is="`main-layout`">
    <router-view />
  </component>
</template>
<script>
import MainLayout from "@/layout/MainLayout.vue";

export default {
  computed: {},
  components: {
    MainLayout,
  },
  // watch: {
  //   $route: {
  //     immediate: true,
  //     handler(to, from) {
  //       document.title = to.meta.title || "standoffhouse.RU";
  //     },
  //   },
  // },
  methods: {},
  // async mounted() {
  //   //прверяем откуда пришёл пользователь
  //   if (
  //     document.referrer.includes("yandex") ||
  //     document.referrer.includes("google")
  //   ) {
  //     document.cookie = `search=${document.referrer}; domain=.${window.location.host}`;
  //   }
  // },
};
</script>

